import { Component, computed, input } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { ButtonComponent, DrawerDirective, IconLegacyComponent, selectWith } from '@ftr/foundation'
import { CartState } from '../../../store'
import { RequestTypeUrlValue } from '../../../types'
import { RequestCartSidePanelComponent } from '../side-panel'

@Component({
  selector: 'ftr-request-cart-side-panel-toggle',
  templateUrl: './request-cart-side-panel-toggle.component.html',
  styleUrl: './request-cart-side-panel-toggle.component.css',
  imports: [ButtonComponent, DrawerDirective, IconLegacyComponent, RequestCartSidePanelComponent],
})
export class RequestCartSidePanelToggleComponent {
  readonly courtSystemId = input.required<Uuid>()
  readonly requestType = input.required<RequestTypeUrlValue>()

  protected readonly numCartItems = selectWith(() => CartState.numCartItems)
  protected readonly hasCartItems = computed(() => this.numCartItems() > 0)
  protected readonly cartButtonAriaLabel = computed(() =>
    this.hasCartItems() ? `${this.numCartItems()} items cart` : 'cart',
  )
}
